import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TraceClassDecorator } from '@sentry/angular';
import { USER_TYPES, USER_TYPE_DATA } from 'src/app/constant/constant';
import { CurrentUserData } from 'src/app/models/User';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
    selector: 'app-thank-you',
    templateUrl: './thank-you.component.html',
    styleUrls: ['./thank-you.component.css']
})
@TraceClassDecorator()
export class ThankYouComponent implements OnInit {
    slug: string = "";
    logo_url: string = "";
    currentUserData: CurrentUserData = {
        selected_user_type: '',
        user_type_data: USER_TYPE_DATA,
        user_types: USER_TYPES
    };

    constructor(
        private utilitiesService: UtilitiesService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly providerstateService: ProviderStateService
    ) { }

    ngOnInit(): void {
        this.slug = this.providerstateService.getProviderSlug();
        this.logo_url = this.providerstateService.getLogoUrl();
        this.route.params.subscribe((params) => {
            this.currentUserData.selected_user_type = params.user_type;
        });
        if (
            !Object.values(this.currentUserData.user_types).includes(
                this.currentUserData.selected_user_type
            )
        ) {
            this.router.navigate(['/' + this.slug + '/notfound']);
        }
        document.getElementById('user-tpe-text').innerText =
            this.currentUserData.user_type_data.filter(
                (ele) =>
                    ele.user_type == this.currentUserData.selected_user_type
            )[0]['text_data'];
    }

    async openLink(
        base_url_name: string,
        link: string,
        target: string
    ): Promise<void> {
        await this.utilitiesService.openWebsiteLinks(
            base_url_name,
            link,
            target
        );
    }
}
